import { styled } from '@mui/material/styles';
import { TabList } from '@mui/lab';
import {
  Autocomplete,
  Box,
  FormControl,
  MenuItem,
  Select,
} from '@mui/material';
import { up, lightPalette } from '../../../../theme';

export const classes = {
  root: 'root',
  tabs: 'tabs',
  tabsBox: 'tabsBox',
  tabPanel: 'tabPanel',
  selectedTab: 'selectedTab',
  tabList: 'tabList',
  backDrop: 'backDrop',
  invoiceSettingModelBox: 'invoiceSettingModelBox',
  invoiceSettingModelFormControl: 'invoiceSettingModelFormControl',
  labelDescription: 'labelDescription',
  checkBoxPaddingLeft: 'paddingForCheckbox',
  descriptionWidth: 'descriptionWidth',
  checkBoxMainClass: 'checkBox',
  gridContainer: 'gridContainer',
  accountDetailGrid: 'accountDetailGrid',
  invoiceSettingHeadings: 'invoiceSettingHeadings',
  accountName: 'accountName',
  apiKeyGrid: 'apiKeyGrid',
  apiKeyOutline: 'apiKeyOutline',
  settingHeading: 'settingHeading',
  mainGridContainer: 'mainGridContainer',
  linearProgress: 'linearProgress',
  creditDetails: 'creditDetails',
  expiryDate: 'expiryDate',
  dataFieldContainer: 'dataFieldContainer',
  dataFieldHeading: 'dataFieldHeading',
  selectAllContainer: 'selectAllContainer',
  invoiceDataFieldLabel: 'invoiceDataFieldLabel',
  dataFieldLabel: 'dataFieldLabel',
  dataFieldsContainer: 'dataFieldsContainer',
  loaderBox: 'loaderBox',
  emailTypography: 'emailTypography',
  generateKeyButton: 'generateKeyButton',
  generateKeyButtonWithoutKey: 'generateKeyButtonWithoutKey',
  downloadKeyButton: 'downloadKeyButton',
  downloadKeyButtonBox: 'downloadKeyButtonBox',
  keySelectionFormKeyBox: 'keySelectionFormKeyBox',
  openKeyGenerationFormBackdrop: 'openKeyGenerationFormBackdrop',
  keySelectionFormKeyNameBox: 'keySelectionFormKeyNameBox',
  keySelectionFormKeyIconBox: 'keySelectionFormKeyIconBox',
  Table_Chart_Button_Box: 'Table_Chart_Button_Box',
  Table_Chart_Button_Inner_wrapped_Box: 'Table_Chart_Button_Inner_wrapped_Box',
  Table_Chart_Button: 'Table_Chart_Button',
  leftSection: 'leftSection',
  rightSection: 'rightSection',
  documentSection: 'documentSection',
  credentialSection: 'credentialSection',
  credentialSectionBackdrop: 'credentialSectionBackdrop',
  CardComponent: 'CardComponent',
  CardHeader: 'CardHeader',
  CloseAction: 'CloseAction',
  CardContent: 'CardContent',
  HeaderTypography: 'HeaderTypography',
  TabLayout: 'TabLayout',
  TabBackground: 'TabBackground',
  TabBackgroundVertical: 'TabBackgroundVertical',
  activeTab: 'activeTab',
  nonActiveTab: 'nonActiveTab',
  divider: 'divider',
  headingText: 'headingText',
  ApilabelDescription: 'ApilabelDescription',
  ApiDropDownlabelDescription: 'ApiDropDownlabelDescription',
  childrenComponent: 'childrenComponent',
  listMainBox: 'listMainBox',
  listMainItem: 'listMainItem',
  listItems: 'listItems',
  listItemTexts: 'listItemTexts',
  verticalActiveTab: 'verticalActiveTab',
  verticalNonActiveTab: 'verticalNonActiveTab',
  TabLayoutVertical: 'TabLayoutVertical',
  widthVeticalCOmponent: 'widthVeticalCOmponent',
  subTabComponent: 'subTabComponent',
  cardAvtar: 'cardAvtar',
  iconBox: 'iconBox',
  cardContianer: 'cardContianer',
  editButton: 'editButton',
  deleteButton: 'deleteButton',
  viewMore: 'viewMore',
  taxMappingText: 'taxMappingText',
  addCredentialButton: 'addCredentialButton',
  addButton: 'addButton',
  newFlowBackdrop: 'newFlowBackdrop',
  cardComponent: 'cardComponent',
  DeleteMemberCardHeader: 'DeleteMemberCardHeader',
  DeleteMemberCardContent: 'DeleteMemberCardContent',
  actionButtonBox: 'actionButtonBox',
  cancelButton: 'cancelButton',
  saveButton: 'saveButton',
  closeAction: 'closeAction',
  generalGrid: 'generalGrid',
};

export const SelectKeyMenu = styled(Select)({
  top: '0.5%',
  borderRadius: '5px 0px 0px 5px',
});

export const SelectTagAutoComplete = styled(Autocomplete)({
  marginTop: '1vh',
  [up('xs')]: {
    width: '15vw',
  },
  [up('sm')]: {
    width: '55vw',
  },
  [up('md')]: {
    width: '42vw',
  },
  [up('lg')]: {
    width: '28vw',
  },
  [up('xl')]: {
    width: '28vw',
  },
  [up('xxl')]: {
    width: '30vw',
  },
});

export const SelectDuplicateDocumentMenu = styled(Select)({
  top: '0.5%',
  borderRadius: '5px',
  width: '15vw',
});
export const CustomTabList = styled(TabList)(({ theme }) => ({
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    height: '0.370vh',
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
  },
}));
export const MenuItemBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});

export const MenuItemContentBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  [up('md')]: {
    marginLeft: '15px',
    width: '60%',
  },
  [up('lg')]: {
    marginLeft: '15px',
    width: '60%',
  },
  [up('xl')]: {
    marginLeft: '15px',
    width: '60%',
  },
  [up('xxl')]: {
    marginLeft: '15px',
    width: '50%',
  },
});

export const MenuItemListBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  [up('md')]: {
    width: '80%',
  },
  [up('lg')]: {
    width: '80%',
  },
  [up('xl')]: {
    width: '80%',
  },
  [up('xxl')]: {
    width: '80%',
  },
});

export const MenuItemIconBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  [up('md')]: {
    width: '22%',
  },
  [up('lg')]: {
    width: '22%',
  },
  [up('xl')]: {
    width: '22%',
  },
  [up('xxl')]: {
    width: '22%',
  },
});

export const CustomMenuItem = styled(MenuItem)({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});

export const CustomFormControl = styled(FormControl)({
  width: '100%',
  marginTop: '15px',
});

export const SettingLoadingContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [up('xs')]: {
    height: '60vh',
  },
  [up('sm')]: {
    height: '70vh',
  },
  [up('md')]: {
    height: '60vh',
  },
  [up('lg')]: {
    height: '80vh',
  },
  [up('xl')]: {
    height: '70vh',
  },
  [up('xxl')]: {
    height: '80vh',
  },
});

export const Root = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    overflow: 'hidden',
    '&::-webkit-scrollbar': {
      width: 0,
    },
    [up('xs')]: {
      height: `calc(100vh - ${theme.spacing(6)});`,
    },
  },
  [`& .${classes.tabsBox}`]: {
    borderBottom: 1,
    borderColor: theme.palette.darkPurple.lightest,
  },
  [`& .${classes.tabList}`]: {
    fontWeight: 400,
    color: theme.palette.shoeWax.darker,
  },
  [`& .${classes.tabPanel}`]: {
    padding: 0,
    marginTop: '1vh',
  },
  [`& .${classes.selectedTab}`]: {
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  [`& .${classes.tabs}`]: {
    fontFamily: 'Heebo',
    fontWeight: 400,
    textTransform: 'none',
    [up('xs')]: {
      padding: '18px 14px',
    },
    [up('sm')]: {
      padding: '8px 14px',
    },
    [up('md')]: {
      padding: '10px 18px',
    },
    [up('lg')]: {
      padding: '12px 22px',
    },
    [up('xl')]: {
      padding: '14px 26px',
    },
    [up('xxl')]: {
      padding: '16px 30px',
    },
  },
  [`& .${classes.descriptionWidth}`]: {
    color: theme.palette.shoeWax.darker,
    // [up('xs')]: {
    //   width: '28vw',
    // },
    // [up('sm')]: {
    //   width: '27vw',
    // },
    // [up('md')]: {
    //   width: '27vw',
    // },
    // [up('lg')]: {
    //   width: '22.5vw',
    // },
    // [up('xl')]: {
    //   width: '25.5vw',
    // },
    // [up('xxl')]: {
    //   width: '20.5vw',
    // },
  },
  [`& .${classes.accountDetailGrid}`]: {
    // backgroundColor: theme.palette.paperWhite.darker,
    marginBottom: '1vh',
    borderWidth: '0px',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    // [up('xs')]: {
    //   height: '35px',
    // },
    // [up('sm')]: {
    //   height: '50px',
    // },
    // [up('md')]: {
    //   height: '55px',
    // },
    // [up('lg')]: {
    //   height: '60px',
    // },
    // [up('xl')]: {
    //   height: '90px',
    // },
    // [up('xxl')]: {
    //   height: '130px',
    // },
  },
  [`& .${classes.invoiceSettingModelBox}`]: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    [up('xs')]: {
      marginTop: '2px',
    },
    [up('sm')]: {
      marginTop: '2px',
    },
    [up('md')]: {
      marginTop: '5px',
    },
  },
  [`& .${classes.invoiceSettingModelFormControl}`]: {
    marginLeft: '15px',
    [up('xs')]: {
      width: '15vw',
    },
    [up('md')]: {
      width: '12vw',
    },
    marginTop: '3px',
  },
  [`& .${classes.settingHeading}`]: {
    color: lightPalette.darkPurple.main,
    marginBottom: '2.7vh',
  },
  [`& .${classes.dataFieldContainer}`]: {
    // scrollbarWidth: 'thin',
    // '&::-webkit-scrollbar': {
    //   width: '0.4em',
    // },
    // '&::-webkit-scrollbar-track': {
    //   background: '#D9D9D9',
    //   borderRadius: '5px',
    // },
    // '&::-webkit-scrollbar-thumb': {
    //   backgroundColor: '#868686',
    //   borderRadius: '5px',
    // },
    borderWidth: '0px',
    borderRadius: '5px',
    marginBottom: '3vh',
    // height: '64vh',
    // overflow: 'auto',
  },
  [`& .${classes.expiryDate}`]: {
    color: lightPalette.shoeWax.semiDark,
    fontWeight: 400,
  },
  [`& .${classes.dataFieldHeading}`]: {
    color: theme.palette.darkPurple.main,
    marginBottom: '5px',
  },
  [`& .${classes.mainGridContainer}`]: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  [`& .${classes.invoiceDataFieldLabel}`]: {
    color: lightPalette.shoeWax.darker,
    marginBottom: '0.9vh',
  },
  [`& .${classes.selectAllContainer}`]: {
    marginTop: '3.4vh',
    marginBottom: '1.5vw',
  },
  [`& .${classes.dataFieldLabel}`]: {
    color: lightPalette.shoeWax.darker,
    marginTop: '2.7vh',
  },
  [`& .${classes.creditDetails}`]: {
    color: lightPalette.darkPurple.main,
    fontWeight: 500,
    marginTop: '0.5vh',
  },
  [`& .${classes.openKeyGenerationFormBackdrop}`]: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.secondaryWhite.main,
  },
  [`& .${classes.linearProgress}`]: {
    width: '17vw',
    height: '7px',
    [up('xs')]: {
      marginTop: '0.5vh',
    },
    [up('md')]: {
      marginTop: '1vh',
    },
    color: theme.palette.primary.main,
  },
  [`& .${classes.apiKeyGrid}`]: {
    // backgroundColor: theme.palette.paperWhite.darker,
    marginBottom: '1vh',
    borderWidth: '0px',
    borderRadius: '5px',
    // [up('xs')]: {
    //   height: '90px',
    // },
    // [up('sm')]: {
    //   height: '100px',
    // },
    // [up('md')]: {
    //   height: '115px',
    // },
    // [up('lg')]: {
    //   height: '130px',
    // },
    // [up('xl')]: {
    //   height: '160px',
    // },
    // [up('xxl')]: {
    //   height: '200px',
    // },
  },
  [`& .${classes.documentSection}`]: {
    // backgroundColor: theme.palette.paperWhite.darker,
    marginBottom: '1vh',
    borderWidth: '0px',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'start',
    // gap: 24,
    // padding: 16,
    borderRadius: '5px',
    height: 'auto',
  },

  [`& .${classes.credentialSection}`]: {
    backgroundColor: theme.palette.paperWhite.darker,
    marginBottom: '1vh',
    marginTop: '1vh',
    borderWidth: '0px',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    // justifyContent: 'space-between',
    alignItems: 'start',
    gap: 24,
    padding: 10,
    borderRadius: '5px',
    height: 'auto',
  },
  [`& .${classes.leftSection}`]: {
    // display: 'flex',
    // justifyContent: 'space-between',
    // alignItems: 'center',
    paddingTop: '1%',
    // flex: 1,
    // gap: 4,
  },
  [`& .${classes.rightSection}`]: {
    // display: 'flex',
    // justifyContent: 'space-between',
    // alignItems: 'center',
    paddingTop: '1%',
    // flex: 1,
    // gap: 4,
  },
  [`& .${classes.apiKeyOutline}`]: {
    width: '32vw',
    marginTop: '1vh',
    fontSize: '14px',
    fontFamily: 'Heebo, sans-serif',
    fontWeight: 400,
    '& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input': {
      height: '2vh',
    },
    '& .MuiInputBase-input': {
      [up('xs')]: {
        height: '0px',
      },
      [up('sm')]: {
        height: '13px',
      },
      [up('md')]: {
        height: '18px',
      },
      [up('lg')]: {
        height: '20px',
      },
      [up('xl')]: {
        height: '25px',
      },
      [up('xxl')]: {
        height: '45px',
      },
    },
  },
  [`& .${classes.invoiceSettingHeadings}`]: {
    color: theme.palette.darkPurple.main,
  },
  [`& .${classes.accountName}`]: {
    color: theme.palette.primary.main,
    // marginTop: '15px',
    // [up('xs')]: {
    //   marginTop: '5px',
    // },
    // [up('sm')]: {
    //   marginTop: '8px',
    // },
    // [up('md')]: {
    //   marginTop: '10px',
    // },
  },
  [`& .${classes.dataFieldsContainer}`]: {
    marginTop: '0.9vh',
  },
  [`& .${classes.labelDescription}`]: {
    paddingTop: '1%',
    // paddingLeft: '1%',
    display: 'flex',
    gap: '15rem',
    height: '100%',
  },
  [`& .${classes.ApilabelDescription}`]: {
    paddingTop: '1%',
    // paddingLeft: '1%',
  },
  [`& .${classes.ApiDropDownlabelDescription}`]: {
    // paddingLeft: '1%',
  },
  [`& .${classes.checkBoxPaddingLeft}`]: {
    letterSpacing: 0,
    fontWeight: 500,
    color: theme.palette.shoeWax.darker,
    whiteSpace: 'nowrap',
  },
  [`& .${classes.checkBoxMainClass}`]: {
    cursor: 'pointer',
    height: '3vh',
    width: '16vw',
    marginBottom: '12px',
    '& .Mui-checked': {
      color: 'rgba(159, 119, 235, 1)',
    },

    [up('xs')]: {
      padding: '0px 0px',
      '& .css-i4bv87-MuiSvgIcon-root': {
        width: '14px',
        height: '14px',
      },
    },
    [up('sm')]: {
      padding: '0px 0px',
      '& .css-i4bv87-MuiSvgIcon-root': {
        width: '16px',
        height: '16px',
      },
    },
    [up('md')]: {
      padding: '1px 0px',
      '& .css-i4bv87-MuiSvgIcon-root': {
        width: '20px',
        height: '20px',
      },
    },
    [up('lg')]: {
      padding: '2px 0px',
      '& .css-i4bv87-MuiSvgIcon-root': {
        width: '20px',
        height: '20px',
      },
    },
    [up('xl')]: {
      padding: '0px',
      '& .css-i4bv87-MuiSvgIcon-root': {
        width: '22px',
        height: '22px',
      },
    },
    [up('xxl')]: {
      padding: '0px',
      '& .css-i4bv87-MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
      },
    },
  },
  [`& .${classes.loaderBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [up('xs')]: {
      height: '60vh',
    },
    [up('sm')]: {
      height: '70vh',
    },
    [up('md')]: {
      height: '60vh',
    },
    [up('lg')]: {
      height: '80vh',
    },
    [up('xl')]: {
      height: '70vh',
    },
    [up('xxl')]: {
      height: '80vh',
    },
  },
  [`& .${classes.emailTypography}`]: {
    overflowWrap: 'anywhere',
    [up('xs')]: {
      width: '85%',
    },
    [up('md')]: {
      width: 'auto',
    },
  },
  [`& .${classes.generateKeyButtonWithoutKey}`]: {
    background: theme.palette.primary.main,
    color: theme.palette.secondaryWhite.main,
    // marginRight: '0.573vw',
    margin: '15px 0px 5px 0px',
    ':hover': {
      background: theme.palette.primary.main,
      color: theme.palette.secondaryWhite.main,
      // marginRight: '0.573vw',
    },
    [up('xs')]: {
      width: '115px',
      height: '30px',
    },
    [up('sm')]: {
      width: '115px',
      height: '30px',
    },
    [up('md')]: {
      width: '125px',
      height: '34px',
    },
    [up('lg')]: {
      width: '140px',
      height: '40px',
    },
    [up('xl')]: {
      width: '155px',
      height: '47px',
    },
    [up('xxl')]: {
      width: '194px',
      height: '54px',
    },
  },
  [`& .${classes.generateKeyButton}`]: {
    borderRadius: '0px 5px 5px 0px',
    background: theme.palette.primary.main,
    color: theme.palette.secondaryWhite.main,
    marginTop: '15px',
    ':hover': {
      background: theme.palette.primary.main,
      color: theme.palette.secondaryWhite.main,
    },
    [up('xs')]: {
      width: '80px',
      height: '33px',
    },
    [up('sm')]: {
      width: '80px',
      height: '34px',
    },
    [up('md')]: {
      width: '90px',
      height: '33px',
    },
    [up('lg')]: {
      width: '90px',
      height: '35px',
    },
    [up('xl')]: {
      width: '120px',
      height: '39px',
    },
    [up('xxl')]: {
      width: '130px',
      height: '42px',
    },
  },
  [`& .${classes.downloadKeyButton}`]: {
    background: lightPalette.pastelLavender.main,
    color: lightPalette.primary.main,
    ':hover': {
      background: lightPalette.pastelLavender.main,
      color: lightPalette.primary.main,
    },
    marginTop: '15px',
    height: '34px',
    [up('xs')]: {
      width: '82px',
      height: '34px',
    },
    [up('sm')]: {
      width: '83px',
      height: '34px',
    },
    [up('md')]: {
      width: '83px',
      height: '34px',
    },
    [up('lg')]: {
      width: '140px',
      height: '35px',
    },
    [up('xl')]: {
      width: '155px',
      height: '41px',
    },
    [up('xxl')]: {
      width: '194px',
      height: '42px',
    },
  },
  [`& .${classes.downloadKeyButtonBox}`]: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    [up('xs')]: {
      width: '85%',
    },
    [up('sm')]: {
      width: '85%',
    },
    [up('md')]: {
      width: '85%',
    },
    [up('lg')]: {
      width: '65%',
    },
    [up('xl')]: {
      width: '70%',
    },
    [up('xxl')]: {
      width: '60%',
    },
  },
  [`& .${classes.backDrop}`]: {
    color: theme.palette.secondaryWhite.main,
    zIndex: theme.zIndex.drawer + 1,
  },
  [`& .${classes.keySelectionFormKeyBox}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  [`& .${classes.keySelectionFormKeyNameBox}`]: {
    display: 'flex',
    width: '80%',
    justifyContent: 'space-between',
  },
  [`& .${classes.keySelectionFormKeyIconBox}`]: {
    display: 'flex',
    width: '22%',
    justifyContent: 'space-between',
  },
  [`& .${classes.Table_Chart_Button_Inner_wrapped_Box}`]: {
    border: `1px solid ${theme.palette.darkPurple.lightest}`,
    borderRadius: '5px',
  },
  [`& .${classes.Table_Chart_Button}`]: {
    margin: theme.spacing(0.5),
    [up('xs')]: {
      width: '70px',
      height: '23px',
    },
    [up('sm')]: {
      width: '87px',
      height: '27px',
    },
    [up('md')]: {
      width: '83px',
      height: '25px',
    },
    [up('lg')]: {
      width: '90px',
      height: '30px',
    },
    [up('xl')]: {
      width: '95px',
      height: '33px',
    },
    [up('xxl')]: {
      width: '103px',
      height: '35px',
    },
  },
  [`& .${classes.Table_Chart_Button_Box}`]: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  [`& .${classes.credentialSectionBackdrop}`]: {
    color: theme.palette.secondaryWhite.main,
    zIndex: theme.zIndex.drawer + 1,
  },
  [`& .${classes.CardComponent}`]: {
    backgroundColor: lightPalette.secondaryWhite.main,
    borderRadius: '5px',
    [up('xs')]: {
      width: '300px',
      height: '300px',
    },
    [up('sm')]: {
      width: '325px',
      height: '325px',
    },
    [up('md')]: {
      width: '340px',
      height: '340px',
    },
    [up('lg')]: {
      width: '380px',
      height: '380px',
    },
    [up('xl')]: {
      width: '410px',
      height: '410px',
    },
    [up('xxl')]: {
      width: '460px',
      height: '460px',
    },
  },
  [`& .${classes.CardHeader}`]: {
    width: '100%',
    color: lightPalette.darkPurple.main,
    background: lightPalette.japanBlush.main,
    [up('xs')]: {
      height: '40px',
    },
    [up('sm')]: {
      height: '60px',
    },
    [up('md')]: {
      height: '60px',
    },
    [up('lg')]: {
      height: '60px',
    },
    [up('xl')]: {
      height: '80px',
    },
    [up('xxl')]: {
      height: '90px',
    },
  },
  [`& .${classes.CardContent}`]: {
    width: '100%',
    [up('xs')]: {
      padding: '6px',
    },
    [up('sm')]: {
      padding: '9px',
    },
    [up('md')]: {
      padding: '14px',
    },
    [up('lg')]: {
      padding: '18px',
    },
    [up('xl')]: {
      padding: '22px',
    },
    [up('xxl')]: {
      padding: '30px',
    },
  },
  [`& .${classes.HeaderTypography}`]: {
    color: lightPalette.darkPurple.main,
  },
  [`& .${classes.CloseAction}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '12px',
      height: '12px',
    },
    [up('sm')]: {
      width: '14px',
      height: '14px',
    },
    [up('md')]: {
      width: '18px',
      height: '18px',
    },
    [up('lg')]: {
      width: '20px',
      height: '20px',
    },
    [up('xl')]: {
      width: '22px',
      height: '22px',
    },
    [up('xxl')]: {
      width: '24px',
      height: '24px',
    },
  },
  [`& .${classes.TabLayout}`]: {
    // paddingTop: '8px',
    textTransform: 'none',
    height: '100%',
  },
  [`& .${classes.TabLayoutVertical}`]: {
    display: 'flex',
    flexGrow: 1,
    bgcolor: 'background.paper',
  },
  [`& .${classes.TabBackground}`]: {
    fontWeight: 400,
    '& .MuiTabs-indicator': {
      backgroundColor: theme.palette.primary.main,
      borderTopLeftRadius: '5px',
      borderTopRightRadius: '5px',
    },
    // [up('xs')]: {
    //   height: '48px',
    // },
    // [up('sm')]: {
    //   height: '48px',
    // },
    // [up('md')]: {
    //   height: '48px',
    // },
    // [up('lg')]: {
    //   height: '56px',
    // },
    // [up('xl')]: {
    //   height: '65px',
    // },
    // [up('xxl')]: {
    //   height: '65px',
    // },
  },
  [`& .${classes.TabBackgroundVertical}`]: {
    borderRight: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.12)',
    height: '100%',
  },
  [`& .${classes.activeTab}`]: {
    minWidth: '8vw',
    height: '30px',
    fontWeight: 'bold',
    color: lightPalette.darkPurple.main,
    borderRadius: '4px 4px 0px 0px',
    backgroundColor: lightPalette.secondaryWhite.main,
    [up('xs')]: {
      fontSize: '12px',
      padding: '20px 60px',
    },
    [up('sm')]: {
      fontSize: '12px',
      padding: '20px 60px',
    },
    [up('md')]: {
      fontSize: '12px',
      padding: '20px 60px',
    },
    [up('lg')]: {
      fontSize: '14px',
      padding: '28px 60px',
    },
    [up('xl')]: {
      fontSize: '14px',
      padding: '33px 60px',
    },
    [up('xxl')]: {
      fontSize: '16px',
      padding: '33px 60px',
    },
  },
  [`& .${classes.verticalActiveTab}`]: {
    // minWidth: '100px',
    height: '15px',
    fontWeight: 'bold',
    color: 'rgba(43,30,89, 1) !important',
    borderRadius: '4px 4px 0px 0px',
    backgroundColor: lightPalette.secondaryWhite.main,
    padding: '12px 12px',
    alignItems: 'flex-start',
    [up('xs')]: {
      fontSize: '12px',
      minWidth: '160px',
    },
    [up('sm')]: {
      fontSize: '12px',
      minWidth: '160px',
    },
    [up('md')]: {
      fontSize: '12px',
      minWidth: '160px',
    },
    [up('lg')]: {
      fontSize: '14px',
      minWidth: '210px',
    },
    [up('xl')]: {
      fontSize: '16px',
      minWidth: '210px',
    },
    [up('xxl')]: {
      fontSize: '16px',
      minWidth: '210px',
    },
  },
  [`& .${classes.verticalNonActiveTab}`]: {
    // minWidth: '160px',
    height: '15px',
    fontWeight: 'normal',
    color: lightPalette.dynamicBlack.main,
    padding: '12px 12px',
    alignItems: 'flex-start',
    [up('xs')]: {
      fontSize: '12px',
      minWidth: '160px',
    },
    [up('sm')]: {
      fontSize: '12px',
      minWidth: '160px',
    },
    [up('md')]: {
      fontSize: '12px',
      minWidth: '160px',
    },
    [up('lg')]: {
      fontSize: '14px',
      minWidth: '210px',
    },
    [up('xl')]: {
      fontSize: '16px',
      minWidth: '210px',
    },
    [up('xxl')]: {
      fontSize: '16px',
      minWidth: '210px',
    },
  },
  [`& .${classes.nonActiveTab}`]: {
    minWidth: '8vw',
    height: '30px',
    color: lightPalette.dynamicBlack.main,
    [up('xs')]: {
      fontSize: '12px',
      padding: '20px 60px',
    },
    [up('sm')]: {
      fontSize: '12px',
      padding: '20px 60px',
    },
    [up('md')]: {
      fontSize: '12px',
      padding: '20px 60px',
    },
    [up('lg')]: {
      fontSize: '14px',
      padding: '28px 60px',
    },
    [up('xl')]: {
      fontSize: '16px',
      padding: '33px 60px',
    },
    [up('xxl')]: {
      fontSize: '16px',
      padding: '33px 60px',
    },
  },
  [`& .${classes.divider}`]: {
    width: '100%',
    marginBottom: '15px',
    marginTop: '15px',
  },
  [`& .${classes.headingText}`]: {
    color: theme.palette.shoeWax.darker,
    paddingBottom: '15px',
  },
  [`& .${classes.childrenComponent}`]: {
    maxHeight: '650px',
    overflowY: 'auto',
  },
  [`& .${classes.widthVeticalCOmponent}`]: {
    width: '100%',
    height: '100%',
  },
  [`& .${classes.subTabComponent}`]: {
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: '#D9D9D9',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#868686',
      borderRadius: '5px',
    },
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    height: `calc(100vh - ${theme.spacing(6)} - 240px)`,
    // [up('xs')]: {
    //   height: '50vh',
    // },
    // [up('sm')]: {
    //   height: '50vh',
    // },
    // [up('md')]: {
    //   height: '50vh',
    // },
    // [up('lg')]: {
    //   height: '63vh',
    // },
    // [up('xl')]: {
    //   height: '63vh',
    // },
    // [up('xxl')]: {
    //   height: '63vh',
    // },
  },
  [`& .${classes.cardAvtar}`]: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px solid #075593',
  },
  [`& .${classes.iconBox}`]: {
    width: '25px',
    height: '25px',
  },
  [`& .${classes.cardContianer}`]: {
    minWidth: '275px',
    padding: '5px',
    borderRadius: '5px',
    boxShadow: '3px',
    border: `1px solid ${lightPalette.darkGrey.light}`,
  },
  [`& .${classes.editButton}`]: {
    height: '38px',
    minWidth: '40px',
    backgroundColor: 'rgba(159,119,235, 0.2)',
  },
  [`& .${classes.deleteButton}`]: {
    border: '1px solid grey',
    height: '38px',
    minWidth: '40px',
  },
  [`& .${classes.viewMore}`]: {
    marginTop: '8px',
    cursor: 'pointer',
  },
  [`& .${classes.taxMappingText}`]: {
    marginTop: '16px',
    paddingTop: '8px',
    borderTop: '1px solid #ddd',
  },
  [`& .${classes.addCredentialButton}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'end',
    paddingBottom: '10px',
  },
  [`& .${classes.addButton}`]: {
    padding: '6px',
  },
  [`& .${classes.newFlowBackdrop}`]: {
    color: theme.palette.secondaryWhite.main,
    zIndex: theme.zIndex.drawer + 1,
  },
  [`& .${classes.cardComponent}`]: {
    borderRadius: '5px',
    [up('xs')]: {
      width: '295px',
    },
    [up('sm')]: {
      width: '410px',
    },
    [up('md')]: {
      width: '425px',
    },
    [up('lg')]: {
      width: '500px',
    },
    [up('xl')]: {
      width: '530px',
    },
    [up('xxl')]: {
      width: '650px',
    },
  },
  [`& .${classes.DeleteMemberCardHeader}`]: {
    width: '100%',
    color: theme.palette.darkPurple.main,
    background: theme.palette.japanBlush.main,
    [up('xs')]: {
      height: '40px',
    },
    [up('sm')]: {
      height: '60px',
    },
    [up('md')]: {
      height: '60px',
    },
    [up('lg')]: {
      height: '60px',
    },
    [up('xl')]: {
      height: '80px',
    },
    [up('xxl')]: {
      height: '90px',
    },
  },
  [`& .${classes.DeleteMemberCardContent}`]: {
    marginTop: '20px',
    width: '100%',
    [up('xs')]: {
      padding: '0px 6px',
    },
    [up('sm')]: {
      padding: '0px 9px',
    },
    [up('md')]: {
      padding: '0px 14px',
    },
    [up('lg')]: {
      padding: '0px 18px',
    },
    [up('xl')]: {
      padding: '0px 22px',
    },
    [up('xxl')]: {
      padding: '0px 30px',
    },
  },
  [`& .${classes.actionButtonBox}`]: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [up('xs')]: {
      height: '35px',
      margin: '10px 0px',
    },
    [up('sm')]: {
      height: '50px',
      margin: '14px 0px',
    },
    [up('md')]: {
      height: '54px',
      margin: '16px 0px',
    },
    [up('lg')]: {
      height: '56px',
      margin: '20px 0px',
    },
    [up('xl')]: {
      height: '60px',
      margin: '20px 0px',
    },
    [up('xxl')]: {
      height: '60px',
      margin: '30px 0px',
    },
  },
  [`& .${classes.cancelButton}`]: {
    backgroundColor: theme.palette.paperWhite.main,
    color: theme.palette.lunarBase.main,
    marginTop: 0,
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '99px',
      height: '40px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
  },
  [`& .${classes.saveButton}`]: {
    marginTop: 0,
    [up('xs')]: {
      width: '80px',
      height: '30px',
      margin: '3px',
    },
    [up('sm')]: {
      width: '99px',
      height: '40px',
      margin: '4px',
    },
    [up('md')]: {
      width: '110px',
      height: '40px',
      margin: '6px',
    },
    [up('lg')]: {
      width: '110px',
      height: '44px',
      margin: '7px',
    },
    [up('xl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
    [up('xxl')]: {
      width: '150px',
      height: '54px',
      margin: '10px',
    },
  },
  [`& .${classes.closeAction}`]: {
    cursor: 'pointer',
    [up('xs')]: {
      width: '10px',
      height: '10px',
    },
    [up('sm')]: {
      width: '12px',
      height: '12px',
    },
    [up('md')]: {
      width: '14px',
      height: '14px',
    },
    [up('lg')]: {
      width: '16px',
      height: '16px',
    },
    [up('xl')]: {
      width: '18px',
      height: '18px',
    },
    [up('xxl')]: {
      width: '20px',
      height: '20px',
    },
  },
  [`& .${classes.generalGrid}`]: {
    scrollbarWidth: 'thin',
    '&::-webkit-scrollbar': {
      width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
      background: '#D9D9D9',
      borderRadius: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#868686',
      borderRadius: '5px',
    },
    // maxHeight: '800px',
    height: `calc(100vh - ${theme.spacing(6)} - 155px)`,

    overflow: 'auto',
    // [up('xs')]: {
    //   height: '69vh',
    // },
    // [up('sm')]: {
    //   height: '69vh',
    // },
    // [up('md')]: {
    //   height: '69vh',
    // },
    // [up('lg')]: {
    //   height: '72vh',
    // },
    // [up('xl')]: {
    //   height: '72vh',
    // },
    // [up('xxl')]: {
    //   height: '72vh',
    // },
    // [up('xs')]: {
    //   maxHeight: '400px',
    // },
    // [up('sm')]: {
    //   maxHeight: '400px',
    // },
    // [up('md')]: {
    //   maxHeight: '400px',
    // },
    // [up('lg')]: {
    //   maxHeight: '425px',
    // },
    // [up('xl')]: {
    //   maxHeight: '450px',
    // },
    // [up('xxl')]: {
    //   maxHeight: '500px',
    // },
  },
}));
